<template>
	<Row class="bg-white">
		<Container>
			<article
				v-if="post"
				class="post-178 page type-page status-publish entry"
			>
				<header class="legal-disclosure">
					<h1
						v-if="post.title"
						v-html="post && post.title"
						class="entry-title"
					></h1>
				</header>

				<div
					class="entry-content legal-disclosure"
					v-html="post.content"
				></div>
			</article>
		</Container>
	</Row>

	<Head>
		<Title v-if="metadata">{{ metadata?.title }}</Title>

		<Link
			rel="canonical"
			:href="config['current_hostname'].slice(0, -1) + $route.path"
		/>

		<Meta
			name="description"
			content="Last Revised: March 4, 2024 Nothing in this Privacy Statement may be construed to create any obligation for the Company beyond what is required by applicable law. California residents click here to access our California Consumer Protection Act (CCPA) Notice. This Privacy Statement (“Privacy Statement” or “Statement”) describes the practices of StocksToTrade.Com Inc. (“StocksToTrade,” “STT,”…"
		/>
	</Head>
</template>

<script setup>
const config = useRuntimeConfig().public;
const affiliateDisclosureDataKey = "affiliate-disclosure-page-data";

const { data: asyncDataResult } = await useAsyncData(
	affiliateDisclosureDataKey,
	async () => {
	const results = await $fetch(
		`${config.hostname}wp-json/wp/v2/pages?slug=affiliate-disclosure&_embed`
	);
	const page = results?.[0];
	if (page) {
		return {
			post: {
				title: page.title.rendered,
				content: page.content.rendered
			},
			metadata: page.yoast_head_json,
			yoast: page.yoast_head
		};
	}
	}
);

// Extract post and metadata for use in template
const post = computed(() => asyncDataResult.value?.post);
const metadata = computed(() => asyncDataResult.value?.metadata);

// Refactoring methods to functions
function head_schema_seo() {
	const experiment = Object.entries(metadata.value);
	const filtered = experiment.filter((item) =>
		["canonical", "schema_json"].includes(item[0])
	);
	return filtered;
}

function head_seo() {
	const experiment = Object.entries(metadata.value);
	const filtered = experiment.filter(
		(item) =>
			![
				"title",
				"robots",
				"canonical",
				"schema_json",
				"WordPressAuthor_YoastHeadJson_Schema_"
			].includes(item[0])
	);
	return filtered;
}
</script>

<style lang="scss">
@use "../assets/legal-pages" as *;
</style>
